/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useState, useEffect } from 'react'
import { useServiceContext } from '../../../../root'
import ModalConfirmation from '../../../../components/shared/ModalConfirmation'
import HtmlCell from '../../../../components/shared/HtmlCell'
import { toast } from '../../../../services/toast'
import type { Tag } from '../../../../services/api/api.tags'

interface ModalRemoveProps {
  tag: Tag
  onClose: () => void
  onSuccess?: () => void
}

const ModalRemove: React.FC<ModalRemoveProps> = ({ tag, onClose, onSuccess }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter

  const [msg, setMsg] = useState<React.ReactNode>('')
  const [loading, setLoading] = useState<Promise<any> | null>(null)

  useEffect(() => {
    selectMessage()
  }, [])

  const selectMessage = () => {
    const textMsg = (
      <div>
        <HtmlCell>{translate('SETTINGS_TAG_CONFIRM_DELETION_TXT') + ' <b>' + tag.name + '</b>'}</HtmlCell>
      </div>
    )
    setMsg(textMsg)
  }

  const doSave = async () => {
    try {
      const apiCall = context.api.tags.deleteTag(tag.id)
      setLoading(apiCall)
      await apiCall

      toast.success(translate('SETTINGS_TAGS_DELETE_SUCCESS_MSG'))
      if (onSuccess) {
        onSuccess()
      }
      onClose()
    } catch (error: any) {
      const errorMsg = error?.data?.message || error?.message || 'Unknown error'
      toast.error(translate('SETTINGS_TAGS_DELETE_FAIL_MSG') + ': ' + errorMsg)
    } finally {
      setLoading(null)
    }
  }

  return (
    <ModalConfirmation
      titleMsg={translate('REMOVE')}
      loading={loading}
      msg={msg}
      cancelTxt={translate('CANCEL')}
      okTxt={translate('OK')}
      onSubmit={doSave}
      onCancel={onClose}
    />
  )
}

export default ModalRemove
